export const animationFrameInterval = (handler: FrameRequestCallback): (() => void) => {
  let requestId: number

  const wrappedHandler: FrameRequestCallback = (...payload) => {
    handler(...payload)
    requestId = globalThis.requestAnimationFrame(wrappedHandler)
  }

  requestId = globalThis.requestAnimationFrame(wrappedHandler)

  return () => globalThis.cancelAnimationFrame(requestId)
}
